import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./layout/layout.component.route').then((r: { LayoutRoutes: Routes }) => r.LayoutRoutes),
  },
];
